import { defineAppConfig } from '#imports';

export default defineAppConfig({
	monospace: {
		projectSlug: undefined as string | undefined,
	},
});
